 module.exports.onRouteUpdate = function (_ref) {
	var location = _ref.location;

	if(location.pathname.substring(location.pathname.length - 1) != '/'){
		location.pathname += '/';
	}

	_ref.location = location;
	return _ref;
};


// WEBPACK FOOTER //
// ./plugins/router-url-normalizer-plugin/gatsby-browser.js